export interface IDashboardRankingInfo {
  id: string
  index: number
  shopName: string
  valueFormatted: string
}

export interface IDashboardRankingResponse {
  sales: IDashboardRankingInfo[]
  cars: IDashboardRankingInfo[]
}
